import { isNonNullable } from "@ascend-ltd/logic-helpers";
import * as yup from "yup";
import { SystemError } from "../../error";
import { Change, NumberIdentity, Version } from "../../value-objects";
import { BaseTenantEntity, } from "../base-tenant-entity";
const RegularBusinessScopeTypeList = ["default", "user"];
export const isUserRegularBusinessScopeType = (g) => {
    return g.type === "user";
};
export const isDefaultRegularBusinessScopeType = (g) => {
    return g.type === "default";
};
export function newBusinessScope(offices, segments, name) {
    return {
        name: name ?? undefined,
        officeIds: offices.map((i) => new NumberIdentity(i)),
        segmentIds: segments?.map((i) => new NumberIdentity(i)) ?? undefined,
    };
}
export class RegularBusinessScopeEntity extends BaseTenantEntity {
    constructor(value) {
        super(value);
    }
    validator(_) {
        throw new SystemError.NotImplemented("Method not implemented.");
    }
    toValues() {
        return {
            id: this.v.id.id,
            tenantId: this.v.tenantId.id,
            userId: this.v.userId?.id,
            scopes: this.v.scopes.map((s) => {
                return {
                    name: s.name ?? undefined,
                    officeIds: s.officeIds.map((o) => o.getValue()),
                    segmentIds: s.segmentIds?.map((o) => o.getValue()),
                };
            }),
            type: this.v.type,
            ...(this.v.change?.toJson() ?? {}),
            version: this.v.version?.getValue(),
        };
    }
    static newRegularBusinessScope(v) {
        const common = {
            id: new NumberIdentity(v.id),
            tenantId: new NumberIdentity(v.tenantId),
            scopes: v.scopes.map((s) => newBusinessScope(s.officeIds, s.segmentIds, s.name)),
            type: v.type,
            change: Change.hasChange(v) ? new Change(v) : undefined,
            version: v.version !== undefined
                ? new Version({
                    version: v.version,
                })
                : undefined,
        };
        switch (v.type) {
            case "default":
                return new RegularBusinessScopeEntity({
                    ...common,
                });
            case "user":
                return new RegularBusinessScopeEntity({
                    userId: isNonNullable(v.userId)
                        ? new NumberIdentity(v.userId)
                        : undefined,
                    ...common,
                });
        }
    }
    static schema() {
        return {
            ...NumberIdentity.schema(),
            tenantId: NumberIdentity.schema().id,
            userId: NumberIdentity.schema(false).id,
            scopes: yup.array().of(NumberIdentity.schema().id),
            type: yup.string().oneOf([...RegularBusinessScopeTypeList]),
        };
    }
}
//# sourceMappingURL=regular-business-scope-entity.js.map